import clsx from "clsx";
import { useAtom } from "jotai";

import {
  currentQuestionIndexAtom,
  landerQuizQuestionAtom,
} from "../../../lander-quiz.state";
import { LanderQuizQuestionTypeEnum } from "../../../lander-quiz.types";
import { QuestionButton } from "../../shared/question-button/question-button.component";
import { QuestionTitle } from "../../shared/question-title/question-title.component";

export const ButtonsQuestion: React.FC = () => {
  const [currentQuestionIndex] = useAtom(currentQuestionIndexAtom);
  const [currentQuestion, setCurrentQuestion] = useAtom(
    landerQuizQuestionAtom(currentQuestionIndex)
  );

  return (
    <div
      className={clsx(
        "buttons-question",
        currentQuestion.type === LanderQuizQuestionTypeEnum.MultiOptionGrid &&
          "buttons-question--grid"
      )}
    >
      <QuestionTitle title={currentQuestion.title} />
      <div className="buttons-question__options-container">
        {currentQuestion.options?.map((option, optionIndex) => {
          const optionClick = () => {
            const options = currentQuestion.options!.map((option, index) => ({
              ...option,
              isSelected:
                index === optionIndex
                  ? !option.isSelected
                  : [
                      LanderQuizQuestionTypeEnum.SingleOptionButtons,
                      LanderQuizQuestionTypeEnum.YesNoBranchQuestion,
                    ].includes(currentQuestion.type)
                  ? false
                  : option.isSelected,
            }));

            setCurrentQuestion({
              ...currentQuestion,
              options,
              answer:
                options
                  .filter((option) => option.isSelected)
                  .map((option) => option.label)
                  .join(",") || null,
            });
          };

          return (
            <QuestionButton
              key={`option-${currentQuestionIndex}-${optionIndex}`}
              label={option.label}
              isSelected={!!option.isSelected}
              isDisabled={false}
              clickFn={optionClick}
            />
          );
        })}
      </div>
    </div>
  );
};
